const ContactRouter = [

  // Question answer
  {
    path: '/contact/question-answer',
    name: 'ContactQuestionAnswer',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Contact/QuestionAnswer.vue'),
    meta: {
      openSidebarKey: 'contact',
      title: 'Danh sách câu hỏi - câu trả lời'
    }
  },
]

export default ContactRouter;